import { safe_get } from "../../../../report-visuals";
import type { AnalyticsFacet } from "../../../../stores/tars/tars-analytics-store";
import type { ListFacetsResponse } from "../../tars-hooks/useFacetList";

function rowMatchesCanvas(row: Record<string, unknown>, canvasId: number): boolean {
    const cid = row.canvas_id ?? row.canvasId;
    if (cid == null) return true;
    const n = typeof cid === "number" ? cid : Number(cid);
    return Number.isFinite(n) && n === canvasId;
}

export function mapFacetListRows(data: ListFacetsResponse | undefined, canvasId: number): AnalyticsFacet[] {
    const raw = data?.facets ?? data?.items ?? [];
    const rows = raw.filter((r) => rowMatchesCanvas(r as Record<string, unknown>, canvasId));
    return rows.map((row, idx) => {
        const rec = row as Record<string, unknown>;
        const facetIdRaw = rec.facet_id ?? rec.id;
        const facetIdNum = typeof facetIdRaw === "number" ? facetIdRaw : Number(facetIdRaw ?? 0);
        const nestedFacet = rec.facet as Record<string, unknown> | undefined;
        const nestedMore = nestedFacet?.more as Record<string, unknown> | undefined;
        const rowMore = (rec.more as Record<string, unknown> | undefined) ?? nestedMore ?? {};
        const nestedName = safe_get(nestedFacet, "name", undefined);
        const nameRaw =
            safe_get(rowMore, "name", undefined) ??
            safe_get(nestedName, "name", undefined) ??
            safe_get(rec, "name", undefined) ??
            safe_get(rec, "title", undefined) ??
            `Facet ${idx + 1}`;
        const name = typeof nameRaw === "string" ? nameRaw : `Facet ${idx + 1}`;
        const etlJson = safe_get(rec, "etl_json", {}) as Record<string, unknown>;
        const rowVersion = rec.version;
        const version =
            typeof rowVersion === "number" && Number.isFinite(rowVersion) ? rowVersion : undefined;
        const stableId = Number.isFinite(facetIdNum) && facetIdNum > 0 ? facetIdNum : idx + 1;
        return {
            id: String(stableId),
            facet_id: Number.isFinite(facetIdNum) ? facetIdNum : undefined,
            name,
            more: rowMore,
            etl_json: etlJson,
            jsonContent: Object.keys(etlJson).length > 0 ? JSON.stringify(etlJson, null, 2) : "",
            facet_result: (rec.facet_result as Record<string, unknown> | undefined) ?? {},
            ...(version !== undefined ? { version } : {}),
        };
    });
}
